module.exports = {"TXTWCL_SorryX_this_game_is_not_availa_ELL":{"id":"TXTWCL_SorryX_this_game_is_not_availa_ELL","defaultMessage":"На жаль, ця гра недоступна"}}